export type MemberGiftScope = 'SINGLE' | 'DUAL';

export type OpenMemberRequest = {
  id?: string;
  scope: string;
  status: string;
} | null;

export function scopePhrase(scope: string): string {
  if (scope === 'DUAL') return 'Dual LA Pass Gift Card';
  if (scope === 'SINGLE') return 'Single LA Pass Gift Card';
  return 'LA Pass Gift Card';
}

export function memberGiftButtons(input: {
  giveMembers: boolean;
  singleRemaining: number;
  dualRemaining: number;
  openRequest: OpenMemberRequest;
  ownerChannel: string;
  eligible?: boolean;
}): {
  showSingle: boolean;
  showDual: boolean;
  disabled: boolean;
  waitingLine: string;
} {
  const waiting = input.openRequest?.status === 'open';
  const manual = input.giveMembers === false;
  const eligible = input.eligible !== false;
  return {
    showSingle: manual && eligible && (Boolean(waiting) || input.singleRemaining >= 1),
    showDual: manual && eligible && (Boolean(waiting) || input.dualRemaining >= 1),
    disabled: Boolean(waiting),
    waitingLine: waiting
      ? `A ${scopePhrase(input.openRequest?.scope || '')} request has already been sent to @${input.ownerChannel}.`
      : '',
  };
}

export function requestSentCopy(scope: MemberGiftScope, ownerChannel: string): {
  title: string;
  body: string;
} {
  return {
    title: 'Gift Card Request Sent',
    body: `Your ${scopePhrase(scope)} request has been sent to @${ownerChannel}. You will be notified once @${ownerChannel} approves or denies your request.`,
  };
}

export function previewActOut(scope: MemberGiftScope, ownerChannel: string) {
  const openRequest = { scope, status: 'open' as const };
  return {
    writes: 0,
    openRequest,
    sent: requestSentCopy(scope, ownerChannel),
    buttons: memberGiftButtons({
      giveMembers: false,
      singleRemaining: 1,
      dualRemaining: 1,
      openRequest,
      ownerChannel,
    }),
  };
}
